<template>
  <BLayout :colors="$site.colors" :header-title="$t('pages.customer.recovery.title')" :header-back-route="homeRoute">
    <BContainer class="mt-12">
      <div class="max-w-md mx-auto">
        <BErrors :errors="errors" class="mb-6" />

        <BCard :title="$t('pages.customer.recovery.title')" class="mb-4 ">
          <template v-if="success">
            <p class="text-sm text-secondary text-center">
              {{ $t('pages.customer.recovery.passwordResetEmail') }}
            </p>

            <form @submit.prevent="reset">
              <UFormGroup :label="$t('pages.customer.recovery.resetCode')">
                <b-text-input v-model="resetCode" flat />
              </UFormGroup>

              <UButton type="submit" class="mt-3" variant="soft" block>
                {{ $t('pages.customer.recovery.title') }}
              </UButton>
            </form>
          </template>

          <form v-else @submit.prevent="submit">
            <UFormGroup :label="$t('general.email')">
              <b-text-input v-model.trim="email" type="email" flat />
            </UFormGroup>

            <UButton type="submit" :loading="submitting" class="mt-3" variant="soft" block>
              {{ $t('general.submit') }}
            </UButton>
          </form>
        </BCard>
      </div>
    </BContainer>
  </BLayout>
</template>

<script setup lang="ts">
import Utils from '@/utils'

const { $site, $api, $i18n } = useNuxtApp()
const router = useRouter()

definePageMeta({
  tabs: ['user'],
});


const email = ref<string | null>(null)
const resetCode = ref<string | null>(null)
const errors = ref<any[] | null>(null)
const submitting = ref<boolean>(false)
const success = ref<boolean>(false)

const homeRoute = computed(() => {
  return $site.homeRoute || { path: '/' }
})

const submit = async () => {
  errors.value = null
  submitting.value = true

  const sanitizedEmail = Utils.validation.sanitizeEmail(email.value)
  email.value = sanitizedEmail

  if (!sanitizedEmail || !Utils.validation.email(sanitizedEmail)) {
    errors.value = [$i18n.t('pages.customer.login.index.validateEmail')]
    submitting.value = false
    return
  }

  try {
    const response = await $api.auth.sendRecoveryEmail($site.location, sanitizedEmail)

    if (response?.success) {
      success.value = true
    } else {
      errors.value = response?.errors || null
    }
  } catch (error) {
    errors.value = [$i18n.t('general.errorRequest')]
  }

  submitting.value = false
}

const reset = () => {
  if (!resetCode.value || resetCode.value.length == 0) {
    errors.value = ['Please enter the reset code from your email']
    return
  }

  router.push({ path: '/customer/reset', query: { code: resetCode.value } })
}
</script>
